import React from "react";

import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import styles from "../style/layout_components/PremiumCalculationChoice.module.scss";
import { NavLink } from "react-router-dom";

const PremimCalculationChoice = (props) => {
  return (
    <section className={styles.sectionCalculate}>
      <h2>
        <Text field={props.fields.heading} />
      </h2>
      <nav className={styles.calculateNav}>
        <ul id="product_list">
          {(props.fields.items || [])
            .sort((a, b) => {
              return a.fields.order.value > b.fields.order.value ? 1 : -1;
            })
            .map((d, key) => {
              return (
                <li key={key}>
                  <NavLink id={`product_choice_${key}`} to={d.fields.link.url}>
                    <span>
                      <i className={d.fields.iconStyle.value}></i>
                      <Text field={d.fields.linkText} />
                    </span>
                  </NavLink>
                </li>
              );
            })}
        </ul>
      </nav>
    </section>
  );
};

export default withSitecoreContext()(PremimCalculationChoice);
